// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"326":"b09904c6","350":"b09904c6","489":"b09904c6","605":"ea9e5838","827":"b09904c6","840":"b09904c6","986":"b09904c6"}[chunkId] + ".css";
};